import classNames                     from 'classnames';
import React, { ReactNode }           from 'react';
import { StrictCheckboxProps }        from 'semantic-ui-react';
import { useFormikContext }           from 'formik';
import { Cell, Grid }                 from 'styled-css-grid';
import { Checkbox, FieldDescription } from "@src/views/components/forms";


interface GenericEntitySelectionLayoutProps {
    id: string,
    name: string,
    description?: string,
    loading?: boolean,
    disabled?: boolean,
    onChange?: StrictCheckboxProps["onChange"],
    fieldValueName?: string,
    compact?: boolean,
    additionalContent?: ReactNode,
}

const GenericEntitySelectionLayoutDefaultProps = {
    id:                null,
    name:              'Item',
    description:       null,
    loading:           false,
    disabled:          false,
    onChange:          () => {},
    fieldValueName:    null,
    compact:           false,
    additionalContent: null,
} satisfies Partial<GenericEntitySelectionLayoutProps>

function GenericEntitySelectionLayout( _props: GenericEntitySelectionLayoutProps ){

    const props = { ...GenericEntitySelectionLayoutDefaultProps, ..._props };

    let formik = useFormikContext();

    let { fieldValueName, additionalContent, id, name, description, loading, disabled } = props;

    /* If the toggle is active */
    let isActive = formik.values[ props.fieldValueName ];

    let containerClasses = classNames( {
        [ `padding-xs-vertical` ]: props.compact !== false,
        [ `padding-md-vertical` ]: props.compact === false,
    } );

    return (

        <Grid columns={ `1fr auto` } columnGap={ '50px' } className={ containerClasses }>

            <Cell>

                <h3>{ name }</h3>

                {/* Description */ }
                { description && (

                    <FieldDescription>

                        { description }

                    </FieldDescription>
                ) }

                { additionalContent }

            </Cell>
            <Cell>

                {/* Pin state toggle control */ }
                <Checkbox toggle
                          id={ `bool-${ id }` }
                          name={ fieldValueName }
                          disabled={ loading || disabled }
                          onChange={ props.onChange }/>

            </Cell>

        </Grid>
    );
}

export {
    GenericEntitySelectionLayout,
    GenericEntitySelectionLayoutDefaultProps,
    type GenericEntitySelectionLayoutProps,
}
